import React from 'react'

const Soft = () => {
  return (
    <div className="skills__content">
        <h3 className="skills__title">Professional Skills</h3>

        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                <i className="bx bx-badge-check"></i>

                    <div>
                        <h3 className="skills__name">Teamwork</h3>
                        
                    </div>
                </div>
                <div className="skills__data">
                <i className="bx bx-badge-check"></i>

                    <div>
                        <h3 className="skills__name">Leadership</h3>
                        
                    </div>
                </div>
                <div className="skills__data">
                <i className="bx bx-badge-check"></i>

                    <div>
                        <h3 className="skills__name">Communication</h3>
                        
                    </div>
                </div>
            </div>
            <div className="skills__group">
                <div className="skills__data">
                <i className="bx bx-badge-check"></i>
                    <div>
                        <h3 className="skills__name">Adaptability</h3>
                        
                    </div>
                </div>
                <div className="skills__data">
                <i className="bx bx-badge-check"></i>

                    <div>
                        <h3 className="skills__name">Problem Solving</h3>
                        
                    </div>
                </div>
                <div className="skills__data">
                <i className="bx bx-badge-check"></i>

                    <div>
                        <h3 className="skills__name">Critical Thinking</h3>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Soft